import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';

const mapping = {
  arretes: 'ARRETE',
  avis: 'AVIS',
  deliberations: 'DELIBERATION',
  loi_organiques: 'LOI_ORGANIQUE',
  articles: 'ARTICLE',
  decrets: 'DECRET',
  declarations: 'DECLARATION',
  constitutions: 'CONSTITUTION',
  codes: 'CODE',
  lois: 'LOI',
  conventions: 'CONVENTION',
  decret_lois: 'DECRET_LOI',
  ordonnances: 'ORDONNANCE',
  loi_constits: 'LOI_CONSTIT',
  rapports: 'RAPPORT',
};

const LEGISLATIVE_URL_SEGMENTS = new Map(
  Object.entries(mapping).map(([a, b]) => {
    return [b, a];
  }),
);

const prefixByNature: { [key: string]: string } = {
  CODE: ' du ',
  ARRETE: " de l'",
  AVIS: " de l'",
  CIRCULAIRE: ' de la ',
  CONSTITUTION: ' de la ',
  CONVENTION: ' de la ',
  DECISION: ' de la ',
  DECRET: ' du ',
  DECRET_LOI: ' du décret ',
  LOI: ' de la ',
  LOI_CONSTIT: ' de la ',
  LOI_ORGANIQUE: ' de la ',
  LOI_PROGRAMME: ' de la ',
  ORDONNANCE: " de l'",
  RAPPORT: ' du ',
  DIRECTIVE: ' de la ',
};

export function getLegislationName(
  articleNumber: string,
  legislationType: string,
  legislationName: string,
) {
  let article_prefix = '';
  let legislationNameToDisplay = legislationName;
  if (articleNumber) {
    article_prefix = `Article ${articleNumber}`;
    article_prefix += prefixByNature[legislationType] || ' ';
    legislationNameToDisplay = legislationNameToDisplay.toLowerCase();
  }

  return `${article_prefix}${legislationNameToDisplay}`;
}

export const buildLegislationCodeUrl = ({
  textId,
  otherParams = {},
}: {
  textId: string;
  otherParams?: Object;
}) => {
  const baseUrl = `/l/texts/codes/${textId}`;
  return buildUrlWithParameters(baseUrl, otherParams);
};

export const buildLegislationCodeSectionUrl = ({
  textId,
  sectionId,
  otherParams = {},
}: {
  textId: string;
  sectionId: string;
  otherParams?: Object;
}) => {
  const baseUrl = `/l/texts/codes/${textId}/sections/${sectionId}`;
  return buildUrlWithParameters(baseUrl, otherParams);
};

export const buildLegislationUrl = ({
  textId = '',
  articleId,
  initialVersionId = '',
  isCode = false,
  otherParams = {},
}: {
  textId?: string;
  articleId: string;
  initialVersionId?: string;
  isCode?: boolean;
  otherParams?: Object;
}) => {
  if (isCode && textId && initialVersionId) {
    const baseCodeUrl = `/l/texts/codes/${textId}/articles/${initialVersionId}`;
    const params = { version: articleId, ...otherParams };
    return buildUrlWithParameters(baseCodeUrl, params);
  }
  const baseOtherUrl = `/l/${articleId}`;
  return buildUrlWithParameters(baseOtherUrl, otherParams);
};

export function getUrlSegmentFromTextType(textType: string) {
  return LEGISLATIVE_URL_SEGMENTS.get(textType);
}

export function buildLegislationTextUrl(
  parentTextNature: string,
  parentTextId: string,
) {
  const textType = getUrlSegmentFromTextType(parentTextNature);
  const url = `/l/texts/${textType}/${parentTextId}`;
  return url;
}

export function getLegislationUrl(
  leg_id: string,
  textNature: string,
  textType: string,
) {
  if (textType === 'TEXT') {
    if (textNature === 'CODE') buildLegislationCodeUrl({ textId: leg_id });
    return buildLegislationTextUrl(textNature, leg_id);
  }
  return `/l/${leg_id}`;
}

export const isValidHash = (hash: string): boolean =>
  Boolean(!hash.match(/#:~:text=/g));
